import React from 'react';

export type NcLegacyLinkPropsT = {
  children: React.ReactNode;
  href: string;
  className?: string;
};

export const NcLegacyLink = ({
  href,
  children,
  className,
}: NcLegacyLinkPropsT) => {
  return (
    <a href={href} {...(className ? { className } : {})}>
      {children}
    </a>
  );
};
